import { render } from "./ReportsTable.vue?vue&type=template&id=45564206&scoped=true"
import script from "./ReportsTable.vue?vue&type=script&lang=js"
export * from "./ReportsTable.vue?vue&type=script&lang=js"

import "./ReportsTable.vue?vue&type=style&index=0&id=45564206&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45564206"]])

export default __exports__